var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "9", height: "17", viewBox: "0 0 9 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M.304 1.574l6.59 5.82a.9.9 0 0 1 .004 1.345L.3 14.629a.9.9 0 1 0 1.2 1.342l6.597-5.89a2.7 2.7 0 0 0-.01-4.036L1.497.225a.902.902 0 0 0-1.194 1.35z", fill: "currentColor" })
  );
});